// tslint:disable
import * as Preact from 'preact'
import { firebaseInstance } from '../../../../db/firebase'
import { IClip } from '../../../../../types'
import * as styles from './index.css'
import { bem } from '@nrk/dh-utils'
import { sleep } from '../../../../../lib/promise-utils'
import { waitUntil } from '../../../../../lib/wait-until'

const { h, Component } = Preact

class LikeButton extends Component<
  { clip: IClip; notClickable?: boolean },
  { liked?: boolean; likeCount?: number; hidden: boolean; disabled: boolean }
> {
  public state = {
    liked: undefined,
    likeCount: undefined,
    hidden: true,
    disabled: false
  }
  public componentDidMount() {
    this.getLikeState(this.props.clip.id)
  }

  public componentWillReceiveProps(nextProps: { clip: IClip }) {
    if (this.props.clip.id !== nextProps.clip.id) {
      this.setState({ hidden: true })
      this.getLikeState(nextProps.clip.id)
    }
  }

  public getLikeState = async (id: string) => {
    if (!firebaseInstance) {
      await waitUntil(() => !!firebaseInstance, 1000).catch(console.error)
    }
    if (firebaseInstance) {
      const [liked, likeCount] = await Promise.all([
        firebaseInstance.getLikeState(id),
        firebaseInstance.getLikeCount(id)
      ])
      if (id !== this.props.clip.id) return
      this.setState({ liked, likeCount, hidden: false })
    }
  }

  public toggleLikeState = async () => {
    const { id } = this.props.clip
    const { liked, likeCount } = this.state
    const didLike: boolean = !liked
    const newLikeCount = didLike ? likeCount + 1 : Math.max(0, likeCount - 1)
    this.setState({
      liked: didLike,
      likeCount: newLikeCount,
      hidden: false,
      disabled: true
    })

    await waitUntil(() => !!firebaseInstance, 1000).catch(console.error)
    if (firebaseInstance) {
      await firebaseInstance.toggleLikeState(id)
      const likeCount = await firebaseInstance.getLikeCount(id)

      if (id === this.props.clip.id) {
        this.setState({
          likeCount,
          hidden: false,
          disabled: false
        })
      }
    }
  }
  public render() {
    const { liked, likeCount, hidden, disabled } = this.state
    const { clip, notClickable } = this.props
    const { likes: likesFromDb } = clip

    if (notClickable) {
      return (
        <div class={bem(styles['like-button'], { hidden, hoverable: false })}>
          <LikeIcon liked={liked} />
          <span class={styles['like-button__text']}>
            {likeCount !== undefined ? likeCount : likesFromDb}
          </span>
        </div>
      )
    }
    return (
      <button
        onClick={this.toggleLikeState}
        disabled={disabled}
        class={bem(styles['like-button'], { hidden, hoverable: true })}
      >
        <LikeIcon liked={liked} />

        <span class={styles['like-button__text']}>
          {likeCount !== undefined ? likeCount : likesFromDb}
        </span>
      </button>
    )
  }
}

const LikeIcon = ({
  liked = false
}: {
  unhoverable?: boolean
  liked: boolean
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      class={bem(styles['like-button__icon'], { liked })}
    >
      <path
        class={styles['like-button__icon-stroke']}
        d="M7.5 13.8l-.5-.5c-4.7-4.1-6-5.5-6-8 0-2.1 1.6-3.9 3.7-3.9 1.3 0 2.2.6 2.8 1.3a4 4 0 0 1 2.8-1.2c2 0 3.7 1.7 3.7 3.9 0 2.5-1.3 3.9-6 8l-.5.4zM4.7 2.5C3.2 2.5 2 3.8 2 5.4c0 1.9.9 3.2 5.5 7.1 4.6-4 5.5-5.2 5.5-7.1 0-1.6-1.2-2.9-2.7-2.9-1.2 0-1.9.7-2.5 1.4l-.3.4-.4-.4c-.6-.7-1.3-1.4-2.4-1.4z"
      />
      <path
        class={styles['like-button__icon-fill']}
        d="M10.3,1.5C9,1.5,8.2,2.1,7.5,2.8C6.8,2.1,6,1.5,4.7,1.5C2.6,1.5,1,3.2,1,5.4c0,2.5,1.3,3.9,6,8l0.5,0.5L8,13.3
    c4.7-4.1,6-5.5,6-8C14,3.2,12.4,1.5,10.3,1.5z"
      />
    </svg>
  )
}

export { LikeButton }
